import getConfig from 'next/config';
import type { FC, ReactNode } from 'react';

import { isBezProtsentovPage } from '@src/utils/routing';

export const IS_PROMO_FEATURE_ENABLED = getConfig().publicRuntimeConfig.isPromoEnabled === 'enabled';

export const getPromoVariant = <TProps>(path: string, aVariant: ReactNode, bVariant: ReactNode): FC<TProps> =>
  (!isBezProtsentovPage(path) && IS_PROMO_FEATURE_ENABLED ? aVariant : bVariant) as FC<TProps>;
